// handleLoginToken.js
'use strict';
import { push, replace } from '../action/navigationAction.js';
import fetchConfigurationsBootstrap from '../action/fetchConfigurationsBootstrap.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import getIsRemoteConfigMerged from '../selector/getIsRemoteConfigMerged.js';
import { ManageProfileType } from '../resource/profileConstants.js';
import { CONFIG_PRIORITY_PRESENCE_USER } from '../resource/configPriority.js';
import { getIsIosSafari, getIsInPwa } from '../resource/getUserAgent.js';
import { login as loginModal } from '../resource/modalId.js';
import { shouldShowPwaSafariToast } from '../resource/UIPreferences.js';
import getLoginData from '../selector/getLoginData.js';
import openSetPasswordDirectorModal from '../action/openSetPasswordDirectorModal.js';
import { getIsChinaPartner } from '../resource/partner.js';
import getRouterData from '../selector/getRouterData.js';

/**
 * Handle login token
 * @kind action
 * @param {string} {token} - action param.
 * @return {Promise} Action promise.
 */
const handleLoginToken =
  ({ token }) =>
  async (dispatch, getState) => {
    const isChinaPartner = getIsChinaPartner();
    const state = getState();
    dispatch(
      removeModals({
        ids: [
          loginModal.FORGOT_PASSWORD_PHONE_VERIFY,
          loginModal.FORGOT_PASSWORD_EMAIL_VERIFY,
          loginModal.PHONE_VERIFY,
          loginModal.EMAIL_VERIFY,
        ],
        transitionStatus: 'leaving',
      })
    );

    dispatch(
      removeModals({
        ids: [loginModal.METHOD_SELECT, loginModal.PASSWORD],
        transitionStatus: 'leavingToBottom',
      })
    );

    dispatch(
      removeModals({
        ids: [loginModal.ACCOUNT_REGISTER],
        transitionStatus: 'reversing',
      })
    );

    dispatch(
      fetchConfigurationsBootstrap({
        priority: CONFIG_PRIORITY_PRESENCE_USER,
      })
    );

    const isPresenceUserRemoteConfigMerged = getIsRemoteConfigMerged(
      getState(),
      CONFIG_PRIORITY_PRESENCE_USER
    );

    if (
      getIsIosSafari() &&
      !getIsInPwa() &&
      shouldShowPwaSafariToast &&
      !isChinaPartner &&
      isPresenceUserRemoteConfigMerged
    ) {
      dispatch(addModal({ id: 'PwaSafariToast' }));
    }

    const from = getRouterData(state, ['location', 'state', 'from']);
    const pathname = getRouterData(state, ['location', 'pathname']);

    let target = '/';
    if (from) {
      target = `${from.pathname}${from.search}${from.hash}`;
    }
    if (['/login', '/signup'].includes(pathname)) {
      const searchParams = new URLSearchParams(
        getRouterData(state, ['location', 'search'])
      );
      const redirectUrl = searchParams.get('redirect_url');
      if (redirectUrl) {
        try {
          const url = new URL(redirectUrl);
          if ('https:' === url.protocol && /swag.live$/gi.test(url.hostname)) {
            url.searchParams.set('auth', token);
            location.replace(url.href);
          }
        } catch (error) {
          dispatch({ type: 'error', payload: error });
        }
      }
      return dispatch(replace(target));
    } else {
      const [{ default: digestJwtToken }, { default: fetchFlightCheck }] =
        await Promise.all([
          import('./digestJwtToken.js'),
          import('./fetchFlightCheck.js'),
        ]);
      dispatch(digestJwtToken({ token }));
      dispatch(fetchFlightCheck({ token }));

      //show SetPasswordDirectorModal per login, need to check is user click button related to login.
      const entry = getLoginData(getState(), 'entry');
      if (entry === 'login') {
        dispatch(openSetPasswordDirectorModal());
      }
      if (entry === 'forgotPassword') {
        if (!/\/manage-profile/.test(location.pathname)) {
          dispatch(push(`/manage-profile/${ManageProfileType.ACCOUNT}`));
        }
        dispatch(
          addModal({ id: 'PasswordSetting', transitionStatus: 'coming' })
        );
      }
    }
  };

export default handleLoginToken;
